import { lazyPage } from './lazyPage';
import type { AppRoute } from './types';

const ModuleMenu = lazyPage(() => import('@/pages/ModuleMenu'));
const SportsDashboard = lazyPage(() => import('@/pages/sports/Dashboard'));
const SportsCatalogue = lazyPage(() => import('@/pages/sports/Sports'));
const SportsTeams = lazyPage(() => import('@/pages/sports/Teams'));
const SportsPlayers = lazyPage(() => import('@/pages/sports/Players'));
const SportsCoaches = lazyPage(() => import('@/pages/sports/Coaches'));
const SportsTrainingSchedules = lazyPage(() => import('@/pages/sports/TrainingSchedules'));
const SportsMatches = lazyPage(() => import('@/pages/sports/Matches'));
const SportsAttendance = lazyPage(() => import('@/pages/sports/Attendance'));
const SportsPlayerPerformance = lazyPage(() => import('@/pages/sports/PlayerPerformance'));
const SportsTournaments = lazyPage(() => import('@/pages/sports/Tournaments'));
const SportsAchievements = lazyPage(() => import('@/pages/sports/Achievements'));
const SportsFacilities = lazyPage(() => import('@/pages/sports/Facilities'));
const SportsReports = lazyPage(() => import('@/pages/sports/Reports'));

export const sportsRoutes: AppRoute[] = [
  {
    path: 'sports',
    title: 'Sports',
    children: [
      { path: '', title: 'Sports', component: ModuleMenu },
      { path: 'dashboard', title: 'Dashboard', component: SportsDashboard },
      { path: 'catalogue', title: 'Sports / Games', component: SportsCatalogue },
      { path: 'teams', title: 'Teams', component: SportsTeams },
      { path: 'players', title: 'Players', component: SportsPlayers },
      { path: 'coaches', title: 'Coaches', component: SportsCoaches },
      { path: 'training-schedules', title: 'Training Schedules', component: SportsTrainingSchedules },
      { path: 'matches', title: 'Matches & Fixtures', component: SportsMatches },
      { path: 'attendance', title: 'Attendance', component: SportsAttendance },
      { path: 'performance', title: 'Player Performance', component: SportsPlayerPerformance },
      { path: 'tournaments', title: 'Tournaments', component: SportsTournaments },
      { path: 'achievements', title: 'Achievements', component: SportsAchievements },
      { path: 'facilities', title: 'Sports Facilities', component: SportsFacilities },
      { path: 'reports', title: 'Sports Reports', component: SportsReports },
    ],
  },
];
